<template>
    <span class="profile-link" @mouseover="hovered = true" @mouseleave="hovered = false">
        <vx-basic-icon size="6" class="mr-2" icon="BriefcaseIcon" />
        <router-link exact :to="link" target="_blank">
            <span class="link-text mr-1">
                {{ practice.name }}
                <vx-basic-icon size="3" icon="ExternalLinkIcon" />
            </span>
        </router-link>
    </span>
</template>

<script>
export default {
    name: 'practice-link',
    props: {
        practice: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            hovered: false
        }
    },
    watch: {},
    computed: {
        link() {
            return {
                name: 'practice-details',
                params: {
                    practiceId: this.practice.id
                }
            }
        }
    },
    created() {}
}
</script>

<style lang="scss" scoped>
.profile-link {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover .link-text {
        color: rgba(var(--vs-primary), 1);
    }
}
</style>
